export default {
  companyRoadmapsMetadata: {
    name: 'ФИО',
    team: 'Команда',
    countNew: 'Новая',
    countInProgress: 'В работе',
    countDone: 'Готово',
    countOverdue: 'Просрочено',
    progress: 'Прогресс',
    link: 'На доску',
    noResults:
      'Пока нет результатов.<br/>Для получения данных, нужно чтобы сотрудники добавили задачи из планов развития на доску вручную.<br/>Автоматически выводятся задачи только из планов развития по 360 из блока «Очевидные зоны роста».',
  },
};
